import { FC, useMemo } from 'react'
import { VideoColumns } from 'room/group-room/presentation/video-columns'
import { GrowthRowContainer } from 'common/presentation/containers'
import styled from '@emotion/styled'
import { ui } from '@beelday/common'
import { SceneVideoUser } from 'video-conference-media'

const VideoContainer = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 0;
	width: 200px;

	${ui.responsive.desktop} {
		width: 300px;
	}

	${ui.responsive.desktopFHD} {
		width: 400px;
	}
`

const ChildrenContainer = styled.div`
	width: 100%;
	flex: 1;
`

type Props = {
	sceneVideoUsers: SceneVideoUser[]
	contentPosition?: 'left' | 'right'
}

const TwoColumnsVideoGrid: FC<Props> = ({
	sceneVideoUsers,
	contentPosition = 'left',
	children,
}) => {
	return (
		<GrowthRowContainer>
			{contentPosition === 'left' ? (
				<>
					<ChildrenContainer>{children}</ChildrenContainer>
					<VideoContainer>
						<VideoColumns sceneVideoUsers={sceneVideoUsers} />
					</VideoContainer>
				</>
			) : (
				<>
					<VideoContainer>
						<VideoColumns sceneVideoUsers={sceneVideoUsers} />
					</VideoContainer>
					<ChildrenContainer>{children}</ChildrenContainer>
				</>
			)}
		</GrowthRowContainer>
	)
}

export default TwoColumnsVideoGrid
